import { Cell } from "@tanstack/react-table";

export function getCellTooltipContent(
  cell: Cell<unknown, unknown>
): string | undefined {
  const value = cell.getValue();
  if (value == null || value === "") return undefined;
  if (Array.isArray(value)) {
    const filtered = value.filter((v) => v != null && v !== "");
    return filtered.length ? filtered.join(", ") : undefined;
  }
  if (typeof value === "object") {
    return undefined;
  }
  return String(value);
}
